import { Button, Tooltip } from "antd";
import "./Btn_No_Login.scss";
import { HiOutlineHeart } from "react-icons/hi2";
import { IoBagOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import Modal_No_Login from "../../../components/Modal_No_Login";
import { getCookie } from "../../../helper/cookie";
import { useState } from "react";

function Btn_No_Login() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = getCookie("token");

  const showModal = () => {
    if (!token) setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="no-login">
        <Link onClick={showModal}>
          <Tooltip title="Danh sách thích">
            <HiOutlineHeart className="no-login-icon" />
          </Tooltip>
        </Link>

        <Link onClick={showModal}>
          <IoBagOutline className="no-login-icon" />
        </Link>

        <Link onClick={showModal}>
          <Button className="no-login-btn sell">Bán ngay</Button>
        </Link>

        <Link to="/register">
          <Button className="no-login-btn sign-Up">Đăng kí</Button>
        </Link>

        <Link to="/login">
          <Button className="no-login-btn sign-In">Đăng nhập</Button>
        </Link>

        <Modal_No_Login isModalOpen={isModalOpen} handleCancel={handleCancel} />
      </div>
    </>
  );
}

export default Btn_No_Login;
